(function () {
    'use strict';

    angular.module("imApp").factory("dataMiningTableComponentService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1968,
                    parameters: parms || {}
                });
            },
            listColumnNames: function (parms) {
                return $ihttp.post({
                    method: 1970,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
